import {SET_USERNAME} from './../constants';
import {SET_CUSTOMER_DATA} from './../constants';
import {SET_SNACK} from './../constants';
import {SET_META_DATA} from './../constants';
import {SET_SUPER_USER} from './../constants';
import {SET_ADMIN_USER_DATA} from './../constants';
import {SET_GENERAL} from './../constants';
import {SET_SW_DATA} from './../constants';
import {SET_CONTRACTOR_DATA} from './../constants';

const initialState = {
    username: '',
    customerData: [],
    contractorData: [],
    adminUserData: [],
    snackData: [],
    swData: {
        open : false,
        title: '',
        description: ''
    },
    metaData: {
        title: 'Some Meta Title',
        description: 'I am a description, and I can create multiple tags',
        canonical: 'http://example.com/path/to/page',
        meta: {
          charset: 'utf-8',
          name: {
            keywords: 'react,meta,document,html,tags'
          }
        }
    },
    superUser: [],
    general: [],
  };
  
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_USERNAME:
            return {
                ...state,
                username: action.payload,
            };
        case SET_CUSTOMER_DATA:
            return {
                ...state,
                customerData: action.payload,
            };
        case SET_SNACK:
            return {
                ...state,
                snackData: action.payload,
            }
        case SET_META_DATA:
            return {
                ...state,
                metaData: action.payload,
            }
        case SET_SUPER_USER:
            return {
                ...state,
                superUser: action.payload,
            }
        case SET_ADMIN_USER_DATA:
            return {
                ...state,
                adminUserData: action.payload,
            }
        case SET_GENERAL:
            return {
                ...state,
                general: action.payload,
            }
        case SET_SW_DATA:
            return {
                ...state,
                swData: action.payload,
            }   
        case SET_CONTRACTOR_DATA:
            return {
                ...state,
                contractorData: action.payload,
            }
        default:
            return state;
    }
};

export default reducer;